import {
  GET_USERINFO,
  RECORD_USERINFO,
  RECORD_TOKENINFO,
  RECORD_MENULIST,
  SET_PreOrderCount
} from './mutation-types'
import { setStore, getStore } from '../utils/storage'
export default {
  // 记录用户信息
  [RECORD_USERINFO] (state, info) {
    state.userInfo = info
    state.login = true
    setStore('userInfo', info)
  },
  // 获取用户信息
  [GET_USERINFO] (state, info) {
    if (state.userInfo && (state.userInfo.username !== info.username)) {
      return
    }
    if (!state.login) {
      return
    }
    if (!info.message) {
      state.userInfo = {...info}
    } else {
      state.userInfo = null
    }
  },
  // 记录token信息
  [RECORD_TOKENINFO] (state, TokenData) {
    state.TokenData = TokenData
    state.login = true
    setStore('TokenData', JSON.stringify(TokenData))
  },
  // 记录menuList信息
  [RECORD_MENULIST] (state, menuList) {
    state.menuList = menuList
  },
  [SET_PreOrderCount](state,num){
    state.PreOrderCount = num
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js